import { render } from "./MainTemplate.vue?vue&type=template&id=672589a8&scoped=true&ts=true"
import script from "./MainTemplate.vue?vue&type=script&lang=ts"
export * from "./MainTemplate.vue?vue&type=script&lang=ts"

import "./MainTemplate.vue?vue&type=style&index=0&id=672589a8&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-672589a8"]])

export default __exports__